define('pages/claim/DiagnosisCode/DiagnosisCodeComponent',[
	'core/can',
	'core/validation',
	'models/DiagnosisCode',
	'template!pages/claim/DiagnosisCode/DiagnosisCodeView.stache'
], function(can, Validation, DiagnosisCode, template) {
	
	function makeDiagnosisCodeList(codes, length) {
		
		// Create List
		var listForDisplay = new can.List,
			letters = 'ABCDEFGH';
		for (var i=0; i<length; i++) {
			var code = (codes.attr(i) === undefined) ? {} : codes.attr(i).attr();
			code.FieldLocator = '67' + String.fromCharCode(65+i);
			listForDisplay.push(code);
		}
		
		// Bind to Claim
		listForDisplay.bind('change', function() {
			var listForModel = [];

			this.each(function(code) {
				if (code.attr('Code')) {
					var o = code.attr();
					delete o.FieldLocator;
					listForModel.push(o);
				}
			});

			codes.replace(listForModel);
		});
		
		return listForDisplay;
	}
	
	return can.Component.extend({
		
		tag: 'claim-diagnosiscodes',
		
		template: can.view(template),
		
		scope: function(attrs, scope, el) {

			return {
				OtherDiagnosisCodes: makeDiagnosisCodeList(attrs.claim.attr('DiagnosisCodes.Other'), 8),
				Claim: attrs.claim
			};
		},


		helpers: {
			isIcd10: function(options) {
				if(this.attr('Claim').attr('TypeOfDiagnosis') === 'icd10'){
					return options.fn();
				} else {
					return options.inverse();
				}
			}
		},
		
		events: {
			
			'inserted': function(el, ev) {
				var self = this,
					scope = this.scope;

				new Validation(el, {
					'Claim.DiagnosisCodes.Principal.Code': {
						validators: {
							notEmpty: {
								message: 'Principal Diagnosis Code is required.'
							},
							callback:  {
								callback: function (value, validator, field) {
									return self.codeValidation(value, validator, field);
								}
							}
						}
					},
					'Code': {
						validators: {
							callback:  {
								callback: function (value, validator, field) {
									return self.codeValidation(value, validator, field);
								}
							}
						}

					}
				});
			},

			codeValidation: function(value, validator, field) {
				if(value && value.length > 0) {
					var claim = this.scope.attr('Claim'),
						isValidICD10 = DiagnosisCode.isValidICD10(value),
						isValidICD9 = DiagnosisCode.isValidICD9(value),
						typeOfDiagnosis = claim.attr('TypeOfDiagnosis');

					if(typeOfDiagnosis === 'icd10' && !isValidICD10) {
						return {
							valid: false,
							message: 'ICD 10 Diagnosis Code is invalid'
						};
					} else if(typeOfDiagnosis === 'icd9' && !isValidICD9) {
						return {
							valid: false,
							message: 'ICD 9 Diagnosis Code is invalid'
						};
					}
				}

				return true;
			}
		}
	});
});
